const PROTOCOL_RE = /^\d{1,6}[-/]\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}$/;
const BARCODE_RE = /^[A-Za-z]{2}\d{6,}[A-Za-z]{0,4}$/;

export function classifyScanCode(raw) {
  const value = String(raw || "").trim();
  if (!value) return { kind: null, value: "" };
  if (PROTOCOL_RE.test(value) || /\d{2}\/\d{2}\/\d{4}/.test(value)) {
    return { kind: "protocol", value };
  }
  if (BARCODE_RE.test(value) || (/[A-Za-z]/.test(value) && !value.includes("/") && value.length >= 8)) {
    return { kind: "barcode", value: value.toUpperCase() };
  }
  if (value.includes("/") || (/^\d{1,6}-/.test(value) && /\d{4}$/.test(value))) {
    return { kind: "protocol", value };
  }
  return { kind: "barcode", value: value.toUpperCase() };
}

export function looksCompleteScan(raw) {
  const { kind, value } = classifyScanCode(raw);
  if (!kind || value.length < 8) return false;
  if (kind === "protocol") return PROTOCOL_RE.test(value) || /\d{2}\/\d{2}\/\d{4}/.test(value);
  return BARCODE_RE.test(value) || value.length >= 10;
}

export function playScanBeep(ok = true) {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = ok ? 880 : 220;
    gain.gain.value = 0.08;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + (ok ? 0.12 : 0.22));
    osc.onended = () => ctx.close().catch(() => {});
  } catch {
    /* ignore */
  }
}
